import YuJaFITBPreviewModal from "../../components/modals/YuJaFITBPreviewModal";
import React, {useEffect, useRef, useState} from "react";
import {
    ADD_BLANK_TEXT, ASK_YOUR_QUESTION_HERE_PLACEHOLDER,
    BLANK_REGEX,
    BLANK_REGEX_NEW,
    CHARACTERS_REMAINING,
    CHOOSE_MEDIA_TEXT,
    FITB_DUPLICATED_BLANK_NAME_ERROR,
    FITB_EMPTY_BLANK_ERROR,
    FITB_EMPTY_TITLE_ERROR,
    FITB_INPUT,
    FITB_LONG_BLANK_ERROR,
    FITB_QUESTION_LENGTH, GRADE_SCHEMA, PREVIEW_TEXT,
    QUESTION_LENGTH, QUESTION_TYPES,
    TEXTBOX
} from "../../utils/constants";
import {CompositeDecorator, ContentState, Editor, EditorState, Modifier} from "draft-js";
import {customSlice, findWithRegex, notifyError} from "../../utils/helpers";
import {
    checkBlankCountChange,
    checkBlankNameChange,
    checkBlankNameExceed,
    getBlanks,
} from "../../utils/questionUtils";
import {
    updateCorrectAnswers,
    updateTitleInput
} from "../../utils/questionUpdate";
import {
    FITB_BLANK_COUNT_ERROR,
    FITB_BLANK_NAME_ERROR,
    FITB_QUESTION_CHARACTER_LIMIT_EXCEEDED
} from "../../utils/toast-message-constants";
import classes from "../questions.module.css";
import {ReactComponent as ATTACHMENT} from "../../images/attachment_grey.svg";
import {ReactComponent as BLINK} from "../../images/blink_purple.svg";
import YuJaButton from "../../components/standardization/YuJaButton";
import FITBAnswerNew from "./FITBAnswerNew";
import {useLocalStorageNew} from "../../hooks/useLocalStorageNew";
import QuestionGenerateModal from "../../components/modals/QuestionGenerateModal";


export default function FITBQuestionTitleNew({
                                                 gradeSchema=GRADE_SCHEMA.GRADED.key,
                                                 questions,
                                                 setQuestions,
                                                 selectedQuestion,
                                                 questionBuilder = false,
                                                 disabled = false,
                                                 hoverDisplay=false,
                                                 upload,
                                                 children
}) {
    const {
        queTitle = '',
        serialNo = 1,
        questionType,
        correctAnswers,
        imageURL,
        directLinkEvp,
        hasBlankRestriction
    } = selectedQuestion;
    const blankVariableRegex = /Blank [\d]+/;
    const indexToChange = serialNo - 1;
    const [hasFocus, setHasFocus] = useState(false);
    // const [keyCounter, setKeyCounter] = useState(1);
    const [errorMsg, setErrorMsg] = useState("");
    const [previewModalShow, setPreviewModalShow] = useState(false);
    const mediaInputRef = useRef();
    const blankRegex = hasBlankRestriction ? BLANK_REGEX_NEW : BLANK_REGEX;

    const [ ,getHostResource] = useLocalStorageNew(window.location.hostname, {});
    const {platformSetting={}} = getHostResource();
    const {privateEVPLink=""} = platformSetting;
    const [questionGenerateModal, setQuestionGenerateModal] = useState(false);



    const modalConfig = {
        title: QUESTION_TYPES.FITB.description + " " + PREVIEW_TEXT,
        submitButtonText: "Proceed Anyways",
        close: (() => {
            setPreviewModalShow(false)
        }),
        cancelText: "Close"
    };

    const [compositeDecorator,] = useState(new CompositeDecorator([{
        strategy: (contentBlock, callback) => {
            findWithRegex(hasBlankRestriction ? BLANK_REGEX_NEW : BLANK_REGEX, contentBlock, callback);
        }, component: (props) => {
            return (
                <span
                    style={{color: "#0B6F85", fontWeight: 400, fontSize: 15, background: "#EFEFEF", padding: 2, borderRadius: 4}}
                    data-offset-key={props.offsetKey}
                >
                  {props.children}
                </span>
            );
        },
    },]));

    const [editorState, setEditorState] = useState(EditorState.createWithContent(ContentState.createFromText(queTitle), compositeDecorator));

    const setTitleAndCorrectAns = (newTitle) => {
        if (!hoverDisplay) {
            let newQuestions = updateTitleInput(newTitle, indexToChange, questions);
            newQuestions = updateCorrectAnswers(
                arrangeBlanks(newTitle.match(blankRegex)),
                indexToChange,
                newQuestions
            );
            setQuestions(newQuestions);
        }
    };


    const arrangeBlanks = (blankKeys) => {
        let newBlanks = {};
        let maxKeyCounter = 0;

        if (blankKeys) {
            blankKeys.forEach((key) => {
                key = key.replaceAll(")", "").replaceAll("(", "");

                if (correctAnswers[key]) {
                    newBlanks[key] = correctAnswers[key];
                } else {
                    newBlanks[key] = [""];
                }

                if (blankVariableRegex.test(key)) {
                    const keyNumbers = key.match(/\d+/);

                    if (keyNumbers.length === 1) {
                        const keyNumber = Number(keyNumbers[0]);
                        if (maxKeyCounter < keyNumber) {
                            maxKeyCounter = keyNumber;
                        }
                    } else {
                        throw new Error(
                            "Blank key cannot include more than one number substring."
                        );
                    }
                }
            });
        }
        // setKeyCounter(maxKeyCounter + 1);
        return newBlanks;
    };

    const insertText = (text, editorValue) => {
        const currentContent = editorValue.getCurrentContent();
        const currentSelection = editorValue.getSelection();


        const newContent = Modifier.replaceText(
            currentContent,
            currentSelection,
            customSlice(text, QUESTION_LENGTH - currentContent.getPlainText('').replace(blankRegex, '').length)
        );
        const newEditorState = EditorState.push(
            editorValue,
            newContent,
            "insert-characters"
        );
        return EditorState.forceSelection(
            newEditorState,
            newContent.getSelectionAfter()
        );
    };

    const handleAddBlank = () => {
        const currentContent = editorState.getCurrentContent();
        let newBlankNumber = 1;
        const currentText = currentContent.getPlainText();

        if (currentText !== "") {
            const currentBlanks = currentText.match(blankRegex);

            if (currentBlanks) {
                const blankNumbers = currentBlanks.map(match => {
                    const matches = match.match(/\d+/);
                    return matches ? parseInt(matches[0], 10) : null;
                }).filter(number => number !== null);

                while (blankNumbers.includes(newBlankNumber)) {
                    newBlankNumber++;
                }
            }
        }
        const textToInsert = "(Blank " + String(newBlankNumber) + ")";
        const currentContentLength = currentContent.getPlainText('').replace(blankRegex, '').length;
        if (currentContentLength <= FITB_QUESTION_LENGTH){
            const newEditorState = insertText(textToInsert, editorState);
            setEditorState(newEditorState);
            setTitleAndCorrectAns(newEditorState.getCurrentContent().getPlainText());
            setErrorMsg(null);
        } else {
            notifyError(FITB_QUESTION_CHARACTER_LIMIT_EXCEEDED);
        }
    };

    const handlePreview = () => {
        setPreviewModalShow(true);
    }

    const getLengthOfSelectedText = () => {
        const currentSelection = editorState.getSelection();
        const isCollapsed = currentSelection.isCollapsed();

        let length = 0;

        if (!isCollapsed) {
            const currentContent = editorState.getCurrentContent();
            const startKey = currentSelection.getStartKey();
            const endKey = currentSelection.getEndKey();
            const startBlock = currentContent.getBlockForKey(startKey);
            const isStartAndEndBlockAreTheSame = startKey === endKey;
            const startBlockTextLength = startBlock.getLength();
            const startSelectedTextLength = startBlockTextLength - currentSelection.getStartOffset();
            const endSelectedTextLength = currentSelection.getEndOffset();
            const keyAfterEnd = currentContent.getKeyAfter(endKey);
            // console.log(currentSelection);
            if (isStartAndEndBlockAreTheSame) {
                length += currentSelection.getEndOffset() - currentSelection.getStartOffset();
            } else {
                let currentKey = startKey;

                while (currentKey && currentKey !== keyAfterEnd) {
                    if (currentKey === startKey) {
                        length += startSelectedTextLength + 1;
                    } else if (currentKey === endKey) {
                        length += endSelectedTextLength;
                    } else {
                        length += currentContent.getBlockForKey(currentKey).getLength() + 1;
                    }

                    currentKey = currentContent.getKeyAfter(currentKey);
                };
            }
        }
        return length;
    }

    const handleBeforeInput = (e) => {
        const currentContent = editorState.getCurrentContent();
        const currentContentLength = currentContent.getPlainText('').replace(blankRegex, '').length;
        const selectedTextLength = getLengthOfSelectedText();

        // console.log(e);
        if (questionBuilder && disabled) {
            const oldTitle = editorState.getCurrentContent().getPlainText();
            const newTitle = oldTitle.slice(0, editorState.getSelection().getStartOffset()) + e + oldTitle.slice(editorState.getSelection().getEndOffset());
            // console.log(oldTitle, newTitle);
            if (checkBlankCountChange(oldTitle, newTitle, hasBlankRestriction)) {
                notifyError(FITB_BLANK_COUNT_ERROR);
                return 'handled';
            }
            if (checkBlankNameChange(oldTitle, newTitle, hasBlankRestriction)) {
                notifyError(FITB_BLANK_NAME_ERROR);
                return 'handled';
            }
        }

        if (currentContentLength - selectedTextLength > FITB_QUESTION_LENGTH - 1) {
            // notifyError(FITB_QUESTION_CHARACTER_LIMIT_EXCEEDED);
            // console.log('you can type max 150 characters');
            return 'handled';
        }
    }

    const handlePastedText = (pastedText, html) => {
        const selectedText = editorState.getCurrentContent().getPlainText('');
        const rawText = (selectedText ? selectedText : "") + pastedText;

        if (questionBuilder && disabled) {
            const oldTitle = editorState.getCurrentContent().getPlainText();
            const newTitle = oldTitle.slice(0, editorState.getSelection().getStartOffset()) + pastedText + oldTitle.slice(editorState.getSelection().getEndOffset());
            // console.log(oldTitle, newTitle);
            if (checkBlankCountChange(oldTitle, newTitle, hasBlankRestriction)) {
                notifyError(FITB_BLANK_COUNT_ERROR);
                return 'handled';
            }
            if (checkBlankNameChange(oldTitle, newTitle, hasBlankRestriction)) {
                notifyError(FITB_BLANK_NAME_ERROR);
                return 'handled';
            }
        }

        if (rawText.replace(blankRegex, '').length > FITB_QUESTION_LENGTH) {
            // notifyError(FITB_QUESTION_CHARACTER_LIMIT_EXCEEDED);
        }

        const newEditorState = insertText(pastedText, editorState);
        changeTitle(newEditorState);
        // setEditorState(
        //     EditorState.createWithContent(
        //         ContentState.createFromText(rawText.slice(0, QUESTION_LENGTH)),
        //         compositeDecorator
        //     )
        // );
        // console.log(editorState);

        // Important! Tell draft-js you already handled the pasted text
        return 'handled';
    }

    const handleKeyCommand = (command) => {
        if ((command === 'backspace' || command === 'delete') && questionBuilder && disabled) {
            const oldTitle = editorState.getCurrentContent().getPlainText();
            const newTitle = oldTitle.slice(0, editorState.getSelection().getStartOffset() - (editorState.getSelection().getStartOffset() === editorState.getSelection().getEndOffset() ? 1 : 0)) + oldTitle.slice(editorState.getSelection().getEndOffset());
            if (checkBlankCountChange(oldTitle, newTitle, hasBlankRestriction)) {
                notifyError(FITB_BLANK_COUNT_ERROR);
                return 'handled';
            }
            if (checkBlankNameChange(oldTitle, newTitle, hasBlankRestriction)) {
                notifyError(FITB_BLANK_NAME_ERROR);
                return 'handled';
            }
        }
        return 'not-handled';
    };

    const checkError = (title) => {
        if (queTitle === title) return; // If the title is the same as the previous title, return

        if (title.length === 0) { // Check if the question is empty
            setErrorMsg(FITB_EMPTY_TITLE_ERROR);
            return;
        }

        // const oldBlanks = getBlanks(queTitle, true);
        // const newBlanks = getBlanks(title, true);
        let oldBlanks = getBlanks(title, false);
        let newBlanks = getBlanks(title, hasBlankRestriction);
        if (checkBlankNameExceed(oldBlanks)) { // Check if blank name exceeds the limit
            setErrorMsg(FITB_LONG_BLANK_ERROR);
            return;
        }

        if (newBlanks.length === 0) { // Check if the question has at least 1 blank
            setErrorMsg(FITB_EMPTY_BLANK_ERROR);
            return;
        }


        if (newBlanks.length !== new Set(newBlanks).size) {
            setErrorMsg(FITB_DUPLICATED_BLANK_NAME_ERROR)
            return;
        }

        setErrorMsg(null); // If no error, set error message to null
    };

    const changeTitle = (editorSt) => {
        if (editorSt) {
        console.log("title changed: " + editorSt.getCurrentContent().getPlainText());
            if (hasBlankRestriction) {
                checkError(editorSt.getCurrentContent().getPlainText());
            }
            setEditorState(editorSt);
            setTitleAndCorrectAns(editorSt.getCurrentContent().getPlainText());
        } else {
            setEditorState(editorState);
            if (!questionBuilder) {
                setTitleAndCorrectAns(editorState.getCurrentContent().getPlainText());
            }
        }
    }

    useEffect(() => {
        changeTitle();
    }, []);

    useEffect(() => {
        resetQueTitle(queTitle);
    }, [serialNo, questionType]);


    const resetQueTitle = (queTitle) => {
        setEditorState(EditorState.createWithContent(ContentState.createFromText(queTitle), compositeDecorator));
    }


    return (
        <>
            <QuestionGenerateModal
                show={questionGenerateModal}
                gradeSchema={gradeSchema}
                setModalShow={setQuestionGenerateModal}
                questions={questions}
                setQuestions={setQuestions}
                selectedQuestion={selectedQuestion}
                resetQueTitle={resetQueTitle}
            />

            <YuJaFITBPreviewModal
                config={modalConfig}
                queTitle={queTitle}
                show={previewModalShow}
                setModalShow={setPreviewModalShow}
                sumbitButtonShow={false}
                hasBlankRestriction={hasBlankRestriction}
            />
            <div className={classes.FITBEditorBox}>
                <div className={classes.FITBEditorMenuBar}>
                    <YuJaButton
                        title={ADD_BLANK_TEXT}
                        onClick={handleAddBlank}
                        style={{
                            width: 88,
                            height: 35,
                            alignItems: "center",
                            display: "flex",
                            whiteSpace: "nowrap",
                            justifyContent: "center"
                        }}
                    >
                        {ADD_BLANK_TEXT}
                    </YuJaButton>

                    {!!queTitle &&
                        <YuJaButton
                            title={PREVIEW_TEXT}
                            onClick={handlePreview}
                            style={{
                                width: 88,
                                height: 35,
                                alignItems: "center",
                                justifyContent: "center",
                                display: "flex",
                                whiteSpace: "nowrap",
                            }}
                        >
                            {PREVIEW_TEXT}
                        </YuJaButton>
                    }

                    <span style={{flex: 1}}/>
                    {!directLinkEvp && !imageURL && !disabled &&
                        <>
                            {!!privateEVPLink &&
                                <YuJaButton
                                    wrapperStyle={{whiteSpace: 'nowrap'}}
                                    style={{
                                        width: 180,
                                        height: 35,
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        marginRight: 10
                                    }}
                                    onlyIcon={true}
                                    onClick={() => setQuestionGenerateModal(true)}
                                >
                                    <BLINK style={{flexShrink: 0, marginRight: 3}}/> {"Generate Question"}
                                </YuJaButton>
                            }


                            <span
                                tabIndex={0}
                                className={classes.mediaChooserBar}
                                onClick={(e) => mediaInputRef.current.click(e)}
                            >
                                <ATTACHMENT style={{marginRight: 2}}/>
                                {CHOOSE_MEDIA_TEXT}
                                <input
                                    ref={mediaInputRef}
                                    style={{display: "none"}}
                                    type="file"
                                    accept="image/png, image/jpg, image/jpeg, image/jfif, image/pjpeg, image/pjp, video/*"
                                    onChange={upload}
                                />
                        </span>
                        </>

                    }
                </div>
                <div className={classes.FITBEditorWrapper}>
                    <Editor
                        readOnly={questionBuilder && disabled}
                        handleKeyCommand={handleKeyCommand}
                        // customStyleMap={questionBuilder ? {fontSize: "10px"} : {}}
                        // customStyleFn={customStyleFn}
                        ariaLabel={FITB_INPUT}
                        role={TEXTBOX}
                        editorState={editorState}
                        onChange={changeTitle}
                        placeholder={ASK_YOUR_QUESTION_HERE_PLACEHOLDER}
                        spellCheck={true}
                        handleBeforeInput={handleBeforeInput}
                        handlePastedText={handlePastedText}
                        onFocus={() => setHasFocus(true)}
                        onBlur={() => setHasFocus(false)}
                    />
                    <span className={classes.characterCountBox} style={{right: 10, bottom: 5}}>
                        {editorState.getCurrentContent().getPlainText('').replace(blankRegex, '').length}
                        /
                        {QUESTION_LENGTH}
                    </span>
                </div>
            </div>


            {!!errorMsg &&
                <div className="fitb-title-footer" style={{padding: 0}}>
                    <div className="error-display" style={{fontSize: 15}}>
                        {errorMsg}
                    </div>
                </div>
            }

            {!!children && children}
            
            <FITBAnswerNew
                gradeSchema={gradeSchema}
                setQuestions={setQuestions}
                selectedQuestion={selectedQuestion}
                questions={questions}
                editorState={editorState}
                setEditorState={setEditorState}
                compositeDecorator={compositeDecorator}
            />
            
        </>
    );

}